import {types,destroy,getParent} from "mobx-state-tree";

export const myIdea = types.model({
    text: types.string,
    id: types.string,
    date:types.string,
    order: types.optional(types.number,0),
}).actions(self=>({
    change(newText){
        self.text = newText;
    },
    remove(){
        getParent(self,2).removeIdea(self);
    }
}))

export const myIdeasList = types.model({
    ideas : types.optional(types.array(myIdea),[]),
}).actions(self=>({
    addMyIdeas(newData){
        newData.forEach(item =>{
            self.ideas.push(item);
        })
    },
    removeIdea(item){
        destroy(item);
    }
})).views(self => ({
    numberOfChildren() {
        return self.ideas.length
    },
}));